import { makePost, makeGet } from 'src/utils/api-helpers'
import { HOST_API } from 'src/config-global';




// Fonction pour créer un événement via l'API
export async function updateOrganization( data ) {

  const formData = { ...data }
  try {
    // Envoi de la requête POST pour créer l'événement
    const response = await fetch(`${HOST_API}/api/users/update/organization`, {
      method: 'POST',
      body: JSON.stringify(formData),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    // Vérification si la requête a réussi
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Extraction des résultats JSON
    const results = await response.json();
    return results
    
  } catch (err) {
    throw err;
  }
}


// Fonction pour créer un événement via l'API
export async function activationAccount( data ) {

  try {
    // Envoi de la requête POST pour créer l'événement
    const response = await fetch(`${HOST_API}/api/users/account/activation`, {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    // Vérification si la requête a réussi
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Extraction des résultats JSON
    const results = await response.json();
    return results;
      
    
  } catch (err) {
    // Affichage de l'erreur dans la console et renvoi de l'erreur pour la gestion
    // console.error('Error creating event:', err);
    throw err;
  }
}


// ------------------------------------------------------

  export const fetchAllOrganisme = ( opts )=>makeGet(`/api/users/organization/all`, opts);

  export const fetchOrganizationData = ( userID, opts )=>makeGet(`/api/users/${userID}`, opts);

  export const fetchSubscription = ( userID, opts )=>makeGet(`/api/subscriptions/users/${userID}/complete`, opts);

  export const fetchConnexionData = ( userID, opts )=>makeGet(`/api/users/${userID}/connexion/data`, opts);

  export const fetchOrganismeAccessLog = (opts) =>makeGet('/api/users/access/logs/data', opts);

  export const fetchTraineeData = (userID, opts) =>makeGet(`/api/users/trainees/${userID}`, opts);


// Fonction pour créer un événement via l'API
export async function getOrganization( userID ) {

  try {
    // Envoi de la requête POST pour créer l'événement
    const response = await fetch(`${HOST_API}/api/users/${userID}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    // Vérification si la requête a réussi
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Extraction des résultats JSON
    const results = await response.json();
    const { success, data } = results;

    // Si l'API retourne success: true, retourner les données
    if (success) {
      return { user: data };
    }
      
    throw new Error('Failed to create event: API did not return success.');
    
  } catch (err) {
    throw err;
  }
}

  export const cancelSubscription = (payload, opts) =>makePost('/api/subscriptions/cancel', payload, opts);

  export const deleteSubscription = (payload, opts) =>makePost('/api/subscriptions/delete', payload, opts);

  export const changeWordpressStatus = (payload, opts) =>makePost('/api/users/change/wordpress/status', payload, opts);

  export const deleteOrganization = (payload, opts) =>makePost('/api/users/delete/organization', payload, opts);

  export const saveOrganization = (payload, opts) =>makePost('/api/users/create/organization', payload, opts);

  export const resetPassword = (payload, opts) =>makePost('/api/users/password/reset', payload, opts);

  export const saveTraineeData = (payload, opts) =>makePost('/api/users/trainees/save', payload, opts);

  export const changePassword = (payload, opts) =>makePost('/api/users/password/organization/change', payload, opts);

